import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App"; // Your main app file
import ModalMapMain from "./map"; // The component to navigate to

function Main() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/monitoring" element={<ModalMapMain />} />
      </Routes>
    </BrowserRouter>
  );
}

export default Main;
